import { Sidebar } from "@heroui-pro/react";
import { Menu } from "lucide-react";
import { useCallback, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";

import { SidebarBody } from "@/components/shell/app-sidebar";
import { CommandMenu } from "@/components/shell/command-menu";
import { PageErrorBoundary } from "@/components/shell/page-error-boundary";
import { useAuthStore } from "@/stores/authStore";

export const AppLayout = () => {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();
  const [isCommandOpen, setIsCommandOpen] = useState(false);

  const handleLogout = useCallback(() => {
    logout();
    navigate("/login", { replace: true });
  }, [logout, navigate]);

  if (!isLoggedIn) {
    return <Navigate replace to="/login" />;
  }

  const body = (
    <SidebarBody
      onLogout={handleLogout}
      onSearch={() => setIsCommandOpen(true)}
    />
  );

  return (
    <Sidebar.Provider
      className="h-svh overflow-hidden bg-(--background) text-(--foreground)"
      navigate={(href) => navigate(href)}
      variant="inset"
    >
      <Sidebar>{body}</Sidebar>
      {/* The body goes straight in: below 768px the library hides every `.sidebar`, so a nested <Sidebar> leaves the drawer empty. */}
      <Sidebar.Mobile>{body}</Sidebar.Mobile>
      <Sidebar.Main
        className="flex min-h-0 flex-col overflow-hidden"
        style={{ minHeight: 0 }}
      >
        <div className="flex items-center gap-2 px-4 pt-3 md:hidden">
          <Sidebar.Trigger aria-label="Open navigation">
            <Menu className="size-5" />
          </Sidebar.Trigger>
          <span className="text-sm font-semibold">Dukkanti</span>
        </div>
        <div className="flex min-h-0 flex-1 flex-col overflow-auto px-4 pb-6 pt-6 md:px-8 md:pt-8">
          <PageErrorBoundary>
            <Outlet />
          </PageErrorBoundary>
        </div>
      </Sidebar.Main>
      <CommandMenu isOpen={isCommandOpen} onOpenChange={setIsCommandOpen} />
    </Sidebar.Provider>
  );
};
